import { Component, OnInit, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { LaudoInput } from 'src/app/models/laudo-input';
import { LaudoInputFotoAdicional } from 'src/app/models/laudo-input-foto-adicional';
import { FileType, FileReaderService } from 'src/app/services/file-reader.service';
import { forkJoin } from 'rxjs';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageResizeService } from 'src/app/services/image-resize.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';

@Component({
  selector: 'app-form-modal-img-laudo',
  templateUrl: './form-modal-img-laudo.component.html',
  styleUrls: ['./form-modal-img-laudo.component.scss']
})
export class FormModalImgLaudoComponent implements OnInit {

  @ViewChild('modalContent', { static: false }) modalContent;
  @Input() elements: LaudoInput[] = [];
  @Input() fotosAdicionais: LaudoInputFotoAdicional[] = [];

  fotosSelecionadas = new FormArray([]);

  optionFilter = '';
  options: LaudoInput[];
  inputFile: HTMLInputElement;
  loadingModal: boolean = false;
  @Output() cancelEvent = new EventEmitter();
  @Output() saveEvent = new EventEmitter();
  optionFotoAdicional: LaudoInput = new LaudoInput();

  search = '';

  labelAd: string[] = [];

  constructor(private msgService: ModalMsgService, private imageResizeService: ImageResizeService, private fileReaderService: FileReaderService, private modalService: NgbModal) {
    this.optionFotoAdicional.set({ name: 'FOTO_ADICIONAL', label: 'Foto Adicional' }, []);
   }

  ngOnInit() {
    this.createInputFile();
  }

  openSelect(e, f) {
    this.optionFilter = '';
    this.filter(this.optionFilter);
    f.markAllAsTouched();
  }

  filter(value) {
    let v = value.toLowerCase();
    let options = [];
    for (const k in this.elements) {
      let e = this.elements[k];
      let naoSelecionado: boolean = !this.fotosSelecionadas.value.find(f => f.from == e);
      let filtroValido: boolean = e.label.toLowerCase().search(v) > -1;

      if (naoSelecionado && filtroValido) {
        options.push(e);
      }
    }
    this.options = [
      this.optionFotoAdicional,
      ...options.sort((a, b) => !a.required && b.required ? 1 : -1)
    ]
  }

  setFotoOption(f, o) {
    f.patchValue(o);
    f.markAsTouched();
  }

  preencherComoAdicional() {
    this.fotosSelecionadas.controls.forEach(f => {
      let control = f.get('from');
      if (control && !control.value) {
        this.setFotoOption(control, this.optionFotoAdicional);
      }
    });
  }

  createInputFile() {
    this.inputFile = document.createElement('input') as HTMLInputElement;
    this.inputFile.setAttribute('type', 'file');
    this.inputFile.setAttribute('accept', FileType.image);
    this.inputFile.setAttribute('multiple', 'multiple');
    this.inputFile.onchange = (e: any) => {
      this.loadingModal = true;
      let promiseList = [];

      for (let i = 0; i < e.target.files.length; i++) {
        let promise = this.readAndResizeImage(e.target.files[i]);
        promiseList.push(promise);
      }

      forkJoin(promiseList).toPromise().then(result => {
        result.filter(r => r).forEach(e => {
          let form = new FormGroup({ image: new FormControl(e), from: new FormControl('', [Validators.required]) });
          this.fotosSelecionadas.push(form);
        });
        if(result.filter(r => r).length>0) {
          this.openModal();
        }
      }).finally(() => {
        this.loadingModal = false;
      });
      this.inputFile.value = '';
    }
  }

  async readAndResizeImage(file) {
    try {
      if (['image/jpeg', 'image/png', 'image/tiff', 'image/pjpeg', 'image/pjp'].find(t => t == file.type)) {
        let image = await this.fileReaderService.readAsDataUrl(file);
        image = await this.imageResizeService.resize(image);
        return image;
      } else {
        await this.msgService.openDialog('Tipo não suportado!', 'O arquivo ' + file.name + ' não é uma imagem válida', 'danger');
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  openModal() {
    this.modalService.open(this.modalContent, { ariaLabelledBy: 'modal-basic-title', windowClass: 'modal-fullscreen' }).result
      .then()
      .catch();
  }

  selectFile() {
    this.inputFile.click();
  }

  cancelBtn(modal) {
    this.fotosSelecionadas = new FormArray([]);
    this.cancelEvent.emit();
    modal.close();
    this.fotosSelecionadas = new FormArray([]);
  }

  saveBtn(modal) {

    if (this.fotosSelecionadas.invalid) {
      this.fotosSelecionadas.markAllAsTouched();
      return;
    }

    let labelIsVazio = false;
    for(let i = 0; this.fotosSelecionadas.value.length > i; i++) {
      if(this.fotosSelecionadas.value[i].from.label == 'Foto Adicional') {
        if(!this.labelAd[i] || this.labelAd[i] == ''){
          labelIsVazio = true;
          break;
        }
      }
    }

    if(labelIsVazio) {
      return this.msgService.openDialog(`Campo Ausente!`, `Favor inserir um título para a foto adicional`, 'danger');
    }

    for(let i = 0; this.fotosSelecionadas.value.length > i; i++) {
      let newLaudoInput = new LaudoInput();
      if(this.fotosSelecionadas.value[i].from.label == 'Foto Adicional') {
        newLaudoInput.set({
          name: 'FOTO_ADICIONAL',
          label: 'Foto Adicional',
          image: this.fotosSelecionadas.value[i].image,
          value: this.labelAd[i] }, []);
        let form = new FormGroup({ image: new FormControl(this.fotosSelecionadas.value[i].image), from: new FormControl('', [Validators.required]) });
        this.setFotoOption(form.get('from'), newLaudoInput);
        this.fotosSelecionadas.value.splice(i, 1, form.value);
      }
    }

    this.saveEvent.emit([...this.fotosSelecionadas.value]);
    modal.close();
    this.fotosSelecionadas = new FormArray([]);
    this.optionFotoAdicional.set({ name: 'FOTO_ADICIONAL', label: 'Foto Adicional' }, []);
    this.labelAd = [];
  }

  removerFoto(i) {
    this.fotosSelecionadas.removeAt(i);
  }
}
